import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./base-query";

const claimsAndDisputesAPI = createApi({
    reducerPath: "claimsAndDisputesAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllClaimsAndDisputes: builder.mutation({
            query: ({ type, page, size, search }) => {
                let apiUrl = `admin/disputes?tab_status=${type}&page=${page + 1}&limit=${size}`;

                if (search) {
                    apiUrl += `&search=${search}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["claims-and-disputes"],
        }),
        getClaimById: builder.mutation({
            query: ({ claimId }) => ({
                url: `admin/claims/${claimId}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        manageDisputeStatus: builder.mutation({
            query: ({ disputeId, body }) => ({
                url: `admin/disputes/${disputeId}/status`,
                method: "PATCH",
                body,
            }),
            invalidatesTags: ["claims-and-disputes"],
        }),

        grandClaim: builder.mutation({
            query: ({ claimId, body }) => ({
                url: `admin/claims/${claimId}/settlement`,
                method: "PATCH",
                body,
            }),
            invalidatesTags: ["claims-and-disputes"]
        })
    }),
});

export const {
    useGetAllClaimsAndDisputesMutation,
    useGetClaimByIdMutation,
    useManageDisputeStatusMutation,
    useGrandClaimMutation
} = claimsAndDisputesAPI;

export default claimsAndDisputesAPI;